let chart = {
    toolbar: {
        show: true,
    },
}
let plotOptions = {
    bar: {
        horizontal: false,
        barHeight: '100%',
        distributed: true,
        dataLabels: {
            position: 'bottom',
        },
    },
}
let dataLabels = {
    enabled: true,
    
}
let colors = [
    '#5369f8',
    '#F3B415',
    '#F27036',
    '#663F59',
    '#6A6E94',
    '#4E88B4',
    '#00A7C6',
    '#18D8D8',
    '#A9D794',
    '#46AF78',
    '#A93F55',
    '#8C5E58',
    '#2176FF',
    '#33A1FD',
    '#7A918D',
    '#BAFF29',
]
let yaxis = {
    labels: { show: true },
}
let states = {
    hover: {
        filter: 'none',
    },
}

let tooltip = {
    theme: 'dark',
    x: { show: true },
    
}

const title = {
    text: 'Custom DataLabels',
    align: 'center',
    floating: true,
  }

module.exports = { chart, plotOptions, dataLabels, colors, yaxis, states, tooltip,title }